export default __webpack_public_path__ + "static/media/logo-ed-short.d680608d.svg";